import React, { useEffect, useState } from 'react'
import { Buffer } from 'buffer'
import { report, setUUID } from './actions';

export const enum EventType {
  D10X_OPTIN_PAGE_ERROR = "D10x optin page error",
  D10X_OPTIN_PAGE_VIEWED = "D10x optin page viewed",
  D10X_OPTIN_PAGE_TRIGGER_COPIED = "D10x optin page trigger copied",
  D10X_OPTIN_PAGE_MESSENGER_LINK_CLICKED = "D10x optin page messenger link clicked",
}

export interface ID10xOptPageParams {
  orgId?: string,
  sourceId?: string,
  orgName?: string,
  logoUrl?: string,
  imageUrl?: string,
  trigger?: string,
  messengerLink?: string,
  eventType?: EventType,
}

const App = () => {
  const [data, setData] = useState<ID10xOptPageParams>({});
  const [fontSize, setFontSize] = useState(16); // default font size

  useEffect(() => {
    setUUID()
    // get "data" param from URL
    const urlParams = new URLSearchParams(window.location.search);
    const payload = urlParams.get('data');
    if (payload) {
      let jsonStr = '';
      try {
        jsonStr = Buffer.from(payload, 'hex').toString('utf8');
        const res = JSON.parse(jsonStr)
        setData(res);

        if (res.logoUrl) {
          // set logo image as favicon
          const link = document.createElement('link');
          link.type = 'image/x-icon';
          link.rel = 'shortcut icon';
          link.href = res.logoUrl;
          document.getElementsByTagName('head')[0].appendChild(link);
        } else {
          // set default favicon %PUBLIC_URL%/favicon.ico
          const link = document.createElement('link');
          link.type = 'image/x-icon';
          link.rel = 'shortcut icon';
          link.href = './favicon.ico';
          document.getElementsByTagName('head')[0].appendChild(link);
        }

        report(EventType.D10X_OPTIN_PAGE_VIEWED, res);
      } catch (e) {
        report(EventType.D10X_OPTIN_PAGE_ERROR, { error: e, payload: jsonStr });
        window.location.href = 'https://dynamo.fyi/';
      }
    } else {
      // redirect to https://dynamo.fyi/
      window.location.href = 'https://dynamo.fyi/';
    }
  }, []);

  useEffect(() => {
    if (data.trigger) {
      const maxLength = 16;
      const baseFontSize = 16; // base font size in pixels
      const contentLength = data.trigger.length;
      if (contentLength > maxLength) {
        const newFontSize = (maxLength / contentLength) * baseFontSize;
        setFontSize(newFontSize);
      } else {
        setFontSize(baseFontSize);
      }
    }
  }, [data.trigger]);

  const renderGoToMessenger = () => (
    <div style={{ flex: 1 }} className="innerContent">
      <p className="bold">Send us this message to join:</p>

      <div className="rewardContainer">
        <img 
          className="rewardImage" 
          src='/images/input_background.svg' 
          alt="reward" 
          style={{
            width: '100%',
            height: 'auto',
          }}
        />
        <p 
          id="trigger"
          className="bold" 
          style={{
            position: 'absolute',
            left: '37.5%',
            fontSize: `${fontSize}px`,
          }}>
          {data.trigger}
        </p>
        <img 
          className="rewardImage" 
          src='/images/point.svg' 
          alt="reward" 
          style={{
            position: 'absolute',
            right: '10%',
            top: '50%',
            width: 35.25,
            height: 47.25,
          }}
        />
      </div>

      <p className="bold">Just click SEND on Messenger!</p>

      <button className="button" style={{width: '80%'}} onClick={() => {
        report(EventType.D10X_OPTIN_PAGE_MESSENGER_LINK_CLICKED, data);
        if (data.messengerLink && data.trigger) {
          // copy the trigger message to the clipboard
          navigator.clipboard.writeText(data.trigger);
          // open messenger with the trigger message
          const newLink = new URL(data.messengerLink);
          newLink.searchParams.append('text', data.trigger);
          window.open(newLink, '_blank');
        }
      }}>
        <p className="bold">
          Go directly to Messenger
        </p>
      </button>
    </div>
  )

  const renderGetUpdates = () => (
    <div style={{ 
      flex: 1, 
      maxWidth: 300, 
      textAlign: 'left', 
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
    }} className="innerContent">
      <p className="bold">1. Click on the button below 👇</p>
      <p className="bold">2. After clicking, a popup will open in Messenger—just click the 'Get Updates' button.</p>
      <button className="button" style={{ width: '80%', margin: '0 auto'}} onClick={() => {
        report(EventType.D10X_OPTIN_PAGE_MESSENGER_LINK_CLICKED, data);
        if (data.messengerLink) {
          window.open(data.messengerLink, '_blank');
        }
      }}>
        <p className="bold">
          Open Messenger
        </p>
      </button>
    </div>
  )
    

  return (
    <div className="App">
      <div className="container">
        {data.logoUrl && <img className="logo" id="logo" src={data.logoUrl} alt="logo" />}
        <div className="content">
          <div style={{ flex: 1 }}>
            {data.imageUrl && <img className="hero-image" src={data.imageUrl} alt="logo" />}
          </div>
          {data.messengerLink?.indexOf('https://m.me/rn/') === 0 ? renderGetUpdates() : renderGoToMessenger()}
        </div>
        
        <footer>
          <img className="footer-logo" src="./logo512.png" alt="logo" />
          <p>Powered by Dynamo</p>
        </footer>
      </div>
    </div>
  );
}

export default App;
